import {Component, inject} from '@angular/core';
import {MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {PrudentButtonComponent} from '../../prudent-button/prudent-button.component';

@Component({
  selector: 'app-download-dialog',
  imports: [
    MatDialogContent,
    PrudentButtonComponent,
  ],
  templateUrl: './download-dialog.component.html',
  styleUrl: './download-dialog.component.scss',
})
export class DownloadDialogComponent {
  dialogRef = inject<MatDialogRef<DownloadDialogComponent>>(MatDialogRef);

  close() {
    this.dialogRef.close();
  }
}
